import PropTypes from 'prop-types'
import {
  Box,
  ButtonBase,
  Card,
  CircularProgress,
  Divider,
  Typography,
} from '@mui/material'
import FitnessRings from './Components/FitnessRings'
import { useFitnessTrackerContext } from './Context/FitnessTrackerContext'
import { useTimeRemaining } from './Hooks/useTimeRemaining'
import FitnessStatTile from './Components/FitnessStatTile'
import HourHistory from './Components/HourHistory'
import { TRACKED_METRICS, formatTimeRemaining } from './Utils/utils'
import { useNavigate } from 'react-router-dom'

export default function FitnessTrackerPopover({ onClose }) {
  const { stats, currentHour, historyHours, error, setExpanded } =
    useFitnessTrackerContext()
  const timeRemaining = useTimeRemaining()
  const navigate = useNavigate()

  if (error) {
    return (
      <Card sx={{ p: 3 }}>
        <Typography color="text.secondary">
          Unable to load fitness data.
        </Typography>
      </Card>
    )
  }

  if (!stats || !currentHour) {
    return (
      <Card sx={{ p: 3, width: 340 }}>
        <CircularProgress size={24} />
      </Card>
    )
  }

  return (
    <Card
      sx={{
        width: 340,
        p: 3,
        bgcolor: 'background.paper',
        color: 'text.primary',
        borderRadius: 4,
      }}
    >
      <Box display="flex" justifyContent="space-between" mb={3}>
        <Typography variant="body2">THIS HOUR ({currentHour.hour})</Typography>

        <Typography variant="body2">
          Resets in {formatTimeRemaining(timeRemaining)}
        </Typography>
      </Box>

      <Box display="flex" justifyContent="center">
        <Box sx={{ maxWidth: '120px' }}>
          <FitnessRings stats={currentHour} />
        </Box>
      </Box>

      <Box
        sx={{
          display: 'grid',
          gridTemplateColumns: '1fr 1fr',
          gap: 1,
        }}
      >
        {Object.entries(TRACKED_METRICS).map(([key, { label, colour }]) => (
          <FitnessStatTile
            key={key}
            label={label}
            data={currentHour[key]}
            colour={colour}
          />
        ))}
      </Box>

      <Divider sx={{ my: 2 }} />

      <HourHistory hours={historyHours} />

      <Divider sx={{ my: 2 }} />

      <Box
        mt={2}
        sx={{
          display: 'flex',
          justifyContent: 'center',
          py: 1,
          width: '100%',
        }}
      >
        <ButtonBase
          onClick={() => {
            onClose()
            setExpanded(true)
            navigate('/')
          }}
        >
          <Typography variant="body2">View Full Dashboard</Typography>
        </ButtonBase>
      </Box>
    </Card>
  )
}

FitnessTrackerPopover.propTypes = {
  onClose: PropTypes.func,
}
